module.exports = __webpack_public_path__ + "assets/img/Singapore Botanic Gardens.b12482d6.jpg";